module.exports = __webpack_public_path__ + "static/media/Imaxe.d2a4838d.jpg";